export const SLUG_MIN = 3;
export const SLUG_MAX = 80;
const SLUG_RE = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
const RESERVED = new Set(["login", "signup", "auth", "dashboard", "onboarding", "settings", "api", "admin", "app", "www", "help", "support"]);

export function slugify(text) {
  return (text || "")
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, SLUG_MAX)
    .replace(/-+$/g, "");
}

export const normalizeSlugInput = (value) => value.toLowerCase().replace(/\s+/g, "-");

export function validateSlug(slug) {
  if (!slug) return "Choose a link for your card.";
  if (slug.length < SLUG_MIN) return `Use at least ${SLUG_MIN} characters.`;
  if (slug.length > SLUG_MAX) return `Use ${SLUG_MAX} characters or fewer.`;
  if (!SLUG_RE.test(slug)) return "Use lowercase letters, numbers and single hyphens (not at the start or end).";
  if (RESERVED.has(slug)) return "That link is reserved. Try another.";
  return null;
}

export function validateCardName(name) {
  const t = name.trim();
  if (!t) return "Give your card a name.";
  if (t.length > 150) return "Keep it under 150 characters.";
  return null;
}
